import { render, staticRenderFns } from "./PostApp.vue?vue&type=template&id=408b1bd3&"
import script from "./PostApp.vue?vue&type=script&lang=js&"
export * from "./PostApp.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports